import { Injectable } from '@angular/core';
import { ITabItem } from '@fi-app/utilities/tabs/tabs';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Injectable()
export class GlobalSettingsService {
    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private appTextService: AppTextService,
    ) {}

    getGlobalSettingsTabs(): ITabItem[] {
        const tabs: ITabItem[] = [];
        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.History.List))
            tabs.push({
                Title: this.appTextService.get('history.activity_log'),
                Sref: FiStateNames.History.List,
            });

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Role.List))
            tabs.push({
                Title: this.appTextService.get('common.roles'),
                Sref: FiStateNames.Role.List,
                AddState: FiStateNames.Role.Add,
                showMobileMenu: true,
                showMobileFilter: false,
            });

        /*if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Appearance.View))
            tabs.push({
                Title: this.appTextService.get('common.appearance'),
                Sref: FiStateNames.Appearance.View
            });
         */

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Tag.List))
            tabs.push({
                Title: this.appTextService.get('common.tags'),
                Sref: FiStateNames.Tag.List,
                AddState: FiStateNames.Tag.Add,
                showMobileMenu: true,
                showMobileFilter: true,
            });

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.SiteMap.List))
            tabs.push({
                Title: this.appTextService.get('sitemap.module_name'),
                Sref: FiStateNames.SiteMap.List,
                AddState: FiStateNames.SiteMap.Add,
                showMobileMenu: true,
                showMobileFilter: false,
            });

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.BusinessArea.List))
            tabs.push({
                Title: this.appTextService.get('common.business_areas'),
                Sref: FiStateNames.BusinessArea.List,
                AddState: FiStateNames.BusinessArea.Add,
                showMobileMenu: true,
                showMobileFilter: false,
            });

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.OtherSettings.List))
            tabs.push({
                Title: this.appTextService.get('common.other_settings'),
                Sref: FiStateNames.OtherSettings.List,
            });

        return tabs;
    }
}
